module.exports = __webpack_public_path__ + "img/emailbgc.e7bd5496.png";